import { getApi } from "../../services/httpService";


export function article(){
    return getApi().get('home/article');
}

export function articleDetails(id){
    return getApi().get('gallery/details/'+id);
}